import Document from "./document";

interface Asset {
  id?: number;
  name?: string;
  codeIdentifier?: string;
  notes?: string;
  companyId?: number;
  typeId?: number;
  typeName?: string;
  subtypeId?: number;
  subtypeName?: string;
  parentAssetId?: number;
  isActive?: boolean;
  //fields to copy documents from other asset
  documentsToCopy?: Document[];
}

export const newAsset = (): Asset => {
  return {};
};

export default Asset;
